import Stratto from "./Stratto";

export default Stratto;
